export enum updateJadwaTransferFormFields {
  status = 'status',
  amount = 'amount',
}
